export const state = () => ({
  isMobile: false,
});

export const mutations = {
  change(state, value) {
    state.isMobile = value;
  },
};
